<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M17.4449 5.85223C16.804 4.73773 15.1961 4.73773 14.5552 5.85224L3.83128 24.5026C3.19241 25.6137 3.99441 27 5.27612 27H26.7239C28.0057 27 28.8077 25.6137 28.1689 24.5026C28.1689 24.5026 28.1689 24.5026 28.1689 24.5026L17.4449 5.85223ZM12.8214 4.85531C14.2312 2.40339 17.7688 2.40336 19.1787 4.85529L29.9027 23.5057C31.3081 25.9501 29.5437 29 26.7239 29H5.27612C2.45641 29 0.691906 25.9501 2.09746 23.5057L12.8214 4.85531Z"
			fill="#000"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16 11C16.5523 11 17 11.4477 17 12V17.3333C17 17.8856 16.5523 18.3333 16 18.3333C15.4478 18.3333 15 17.8856 15 17.3333V12C15 11.4477 15.4478 11 16 11Z"
			fill="#000"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.6827 21.9222C17.093 22.2919 17.126 22.9242 16.7564 23.3345L16.743 23.3493C16.3734 23.7597 15.7411 23.7926 15.3307 23.423C14.9204 23.0533 14.8874 22.421 15.2571 22.0107L15.2704 21.9959C15.6401 21.5855 16.2724 21.5526 16.6827 21.9222Z"
			fill="#000"
		/>
	</svg>
</template>
